<template>
  <div class="option-mapping-row">
    <div class="option-mapping-row__col option-mapping-row__col--option">
      <SelectInput
        :id="`opt-${mapping.id}`"
        :modelValue="mapping.optionId"
        @update:modelValue="$emit('update', { optionId: $event, optionLabel: getOptionLabel($event) })"
        :options="optionSelectOptions"
        placeholder="Kies optie..."
        size="sm"
      />
    </div>

    <div class="option-mapping-row__col option-mapping-row__col--code">
      <TextInput
        :id="`code-${mapping.id}`"
        :modelValue="mapping.supplierCode"
        @update:modelValue="$emit('update', { supplierCode: $event })"
        placeholder="P01"
        size="sm"
      />
    </div>

    <div class="option-mapping-row__col option-mapping-row__col--type">
      <SelectInput
        :id="`type-${mapping.id}`"
        :modelValue="mapping.valueType"
        @update:modelValue="$emit('update', { valueType: $event })"
        :options="typeOptions"
        size="sm"
      />
    </div>

    <div class="option-mapping-row__col option-mapping-row__col--actions">
      <Btn
        v-if="mapping.valueType === 'choice_map' || mapping.valueType === 'transform'"
        variant="plain"
        size="xs"
        icon="settings"
        @click="$emit('configure')"
      />
      <Btn
        variant="plain"
        size="xs"
        icon="trash"
        @click="$emit('remove')"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import TextInput from '@/components/inputs/TextInput.vue';
import SelectInput from '@/components/inputs/SelectInput.vue';
import Btn from '@/components/partials/Btn.vue';

export default defineComponent({
  name: 'OptionMappingRow',

  components: { TextInput, SelectInput, Btn },

  props: {
    mapping: { type: Object, required: true },
    productOptions: { type: Array, default: () => [] },
    catalogFields: { type: Array, default: () => [] },
  },

  emits: ['update', 'remove', 'configure'],

  setup(props) {
    const optionSelectOptions = computed(() => [
      { value: null, label: '— kies optie —' },
      ...props.productOptions.map((opt) => ({
        value: opt.id,
        label: opt.label || opt.name || opt.id,
      })),
    ]);

    const typeOptions = [
      { value: 'direct', label: 'Direct' },
      { value: 'transform', label: 'Transform' },
      { value: 'choice_auto', label: 'Keuze (auto)' },
      { value: 'choice_map', label: 'Keuze (handmatig)' },
      { value: 'composite', label: 'Samengesteld' },
      { value: 'formula', label: 'Formule' },
    ];

    function getOptionLabel(optionId) {
      const opt = props.productOptions.find((o) => o.id === optionId);
      return opt?.label || opt?.name || '';
    }

    return { optionSelectOptions, typeOptions, getOptionLabel };
  },
});
</script>

<style scoped lang="scss">
.option-mapping-row {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  padding: 0.375rem 0;
  border-bottom: 1px solid var(--border-color-light);

  &:last-child {
    border-bottom: none;
  }

  &__col {
    &--option { flex: 2; }
    &--code { flex: 1; max-width: 100px; }
    &--type { flex: 1; max-width: 140px; }
    &--actions {
      flex: 1;
      max-width: 120px;
      display: flex;
      justify-content: flex-end;
      gap: 0.25rem;
    }
  }
}
</style>
